import { render, staticRenderFns } from "./ProductColorList.vue?vue&type=template&id=921be1ea&"
import script from "./ProductColorList.vue?vue&type=script&lang=js&"
export * from "./ProductColorList.vue?vue&type=script&lang=js&"
import style0 from "./ProductColorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports